export const CONVERSION_JOURNEY_SERVICE_WISE_DATA = {
    wa: [
        {
            key: 'read',
            label: 'Read',
            color: '#1E75BA',
        },
        {
            key: 'delivered',
            label: 'Delivered',
            color: '#29A653',
        },
        {
            key: 'sent',
            label: 'Sent',
            color: '#7AB4F5',
        },
        {
            key: 'replyCount',
            label: 'Replied',
            color: '#26A5E4',
        },
        {
            key: 'clicked',
            label: 'Clicked',
            color: '#24B2B2',
        },
        {
            key: 'failed',
            label: 'Failed',
            color: '#A92E26',
        },
    ],
    voice: [
        {
            key: 'completed',
            label: 'Completed',
            color: '#29A653',
        },
        {
            key: 'failed',
            label: 'Failed',
            color: '#A92E26',
        },
        {
            key: 'cancelled',
            label: 'Cancelled',
            color: '#C33F38',
        },
        {
            key: 'busy',
            label: 'Busy',
            color: '#DE8644',
        },
        {
            key: 'no_answer',
            label: 'No Answer',
            color: '#DE5E57',
        },
        {
            key: 'out_of_balance',
            label: 'Out of Balance',
            color: '#E25241',
        },
    ],
    sms: [
        {
            key: 'delivered',
            label: 'Delivered',
            color: '#29A653',
        },
        {
            key: 'rejected',
            label: 'Rejected',
            color: '#C33F38',
        },
        {
            key: 'ndnc',
            label: 'NDNC',
            color: '#D4483F',
        },
        {
            key: 'failed',
            label: 'Failed',
            color: '#A92E26',
        },
        {
            key: 'duplicate',
            label: 'Duplicate',
            color: 'text-verified',
        },
        {
            key: 'clicked',
            label: 'Clicked',
            color: '#24B2B2',
        },
    ],
    pushNotification: [
        {
            key: 'delivered',
            label: 'Delivered',
            color: '#29A653',
        },
        {
            key: 'sent',
            label: 'Sent',
            color: '#7AB4F5',
        },
        {
            key: 'clicked',
            label: 'Clicked',
            color: '#24B2B2',
        },
        {
            key: 'failed',
            label: 'Failed',
            color: '#A92E26',
        },
    ],
    mail: [
        {
            key: 'delivered',
            label: 'Delivered',
            color: '#29A653',
        },
        {
            key: 'failed',
            label: 'Failed',
            color: '#A92E26',
        },
        {
            key: 'rejected',
            label: 'Rejected',
            color: '#C33F38',
        },
        {
            key: 'bounced',
            label: 'Bounced',
            color: '#DE8644',
        },
        // {
        //     key: 'opened',
        //     label: 'Opened',
        //     color: '#1E75BA',
        // },
        {
            key: 'clicked',
            label: 'Clicked',
            color: '#24B2B2',
        },
    ],
};
